<template>
  <v-dialog v-model="open" max-width="480">
    <v-card>
      <v-card-title :class="title">
        <h3 :class="title" v-html="icon.title" />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex lg4 md4 xs12 v-for="i in 3" :key="i" :class="['pb-4']">
              <v-icon :class="[`icon-size-${i}`]" v-html="icon.title" />
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="cdnUrl">
            <v-flex>
              <v-text-field
                class="code-input"
                readonly
                v-model="stylesheet"
                :color="primaryColor"
                label="CDN:"
                @click="copy(stylesheet, $event)" />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-text-field
                class="code-input"
                readonly
                v-model="html"
                :color="primaryColor"
                label="HTML:"
                @click="copy(html, $event)"/>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex v-if="npmUrl">
              <v-btn block ripple dark title="NPM" :href="npmUrl" target="_blank" :color="secondaryColor" :class="['code-button']">
                <v-icon medium>mdi-npm</v-icon>
              </v-btn>
            </v-flex>
            <v-flex v-if="gitUrl">
              <v-btn block ripple dark title="GitHub" :href="gitUrl" target="_blank" :color="secondaryColor">
                <v-icon medium>mdi-github-circle</v-icon>
              </v-btn>
            </v-flex>
            <v-flex v-if="serviceUrl">
              <v-btn block ripple dark title="Official website" :href="serviceUrl" target="_blank" :color="secondaryColor">
                <v-icon medium>mdi-link-variant</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :color="primaryColor" dark @click.native="open = false">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'IconPopup',
  computed: {
  },
  data () {
    return {
      open: false,
      services: this.$store.state.services,
      npmUrl: null,
      gitUrl: null,
      cdnUrl: null,
      serviceUrl: null,
      stylesheet: null,
      html: null,
      title: this.$store.state.title,
      primaryColor: this.$store.state.primaryColor || '',
      secondaryColor: this.$store.state.secondaryColor || '',
      icon: {
        title: '',
        service: ''
      }
    }
  },
  watch: {
    open () {
      const services = this.services
      const icon = this.icon
      const service = services[icon.service]
      const title = icon.title
      const cssPrefix = service.cssPrefix
      this.serviceUrl = service.url
      this.npmUrl = service.npm
      this.gitUrl = service.git
      this.cdnUrl = service.cdn
      this.stylesheet = `<link href="${service.cdn}" rel="stylesheet" />`
      this.html = `<i class="${cssPrefix}${service !== 'material.io' ? ' ' + title : ''}" aria-hidden="true">${service === 'material.io' ? title : ''}</i>`
    }
  },
  methods: {
    copy (text, event) {
      this.$clipboard(text)
      event.target.select()
    }
  }
}
</script>
<style>
.icon-size-1
{
  font-size: 24px !important;
  margin-top: 16px;
}

.icon-size-2
{
  font-size: 48px !important;
  margin-top: 6px;
}

.icon-size-3
{
  font-size: 60px !important;
}

.code-input input
{
  font: 400 14px Consolas, Inconsolata, "Courier New", Courier, monospace;
}
</style>



// WEBPACK FOOTER //
// src/components/icon-popup.vue